// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App'
import router from './router'
import store from './store/index.js'

Vue.config.productionTip = false

import apis from './request/http';
Vue.prototype.apis = apis;

Vue.use(ElementUI);

// 滑块
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

import {getToken} from '@/utils/auth'

// 播放器 m3u8
import 'video.js/dist/video-js.css'
import videojs from 'video.js';
import 'videojs-contrib-hls'



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  // sessionStorage.getItem('token')
  // console.log('需要登录111', getToken());
  if(to.meta.requireAuth && localStorage.getItem('token').length == 0) {//判断该路由是否需要登录权限
    console.log('需要登录');
    next({
      path: '/login',
      query: { redirect: to.fullpath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    })
  }else {
    console.log('next page');
    if (to.name == "course" && from.name == "enterprise-approve") {
      this.$router.go();
    }
    next();
  }

});


// WEBPACK FOOTER //
// ./src/main.js